import city from '../region.js'
var CitySelection = {
	$getctlist:function getctlist() {
		let arr = []
		city.forEach(item => {
			let ID = item.ID.substring(item.ID.length - 3, item.ID.length)
			if (ID == '000') {
				arr.push({
					label: item.MC,
					value: item.MC,
					leaf: false,
					PID: item.PID,
					ID: item.ID ,
				})
			}
		})
		let arrback=[
			{
			    label:"上海市",
			    value:"上海市",
			    PID:"310000",
			    ID:"310000000",
				children:[
					{
					   label:"上海市",
					   value:"上海市",
					    PID:"310000",
					    ID:"310000000",
						children:arr
					},
				]
			},
		]
		return arrback
	},
	$ctx:function ctx(e) {
		let nodes = []
		city.map((item, index) => {
			let ID = item.ID.substring(item.ID.length - 3, item.ID.length)
			let PID = item.ID.substring(item.PID.length - 3, item.PID.length)
			if (e.level == 0) {
				if (PID == '000') {
					nodes.push({
						label: item.MC,
						value: item.MC,
						leaf: false,
						PID: item.PID,
						ID: item.ID
					})
				}
			} else if (e.level == 1) {
				if (PID == '000') {
					nodes.push({
						label: item.MC,
						value: item.MC,
						leaf: false,
						PID: item.PID,
						ID: item.ID
					})
				}
			} else if (e.level == 2) {
				if (ID == '000' && PID != '000') {
					nodes.push({
						label: item.MC,
						value: item.MC,
						leaf: true,
						PID: item.PID,
						ID: item.ID
					})
				}
			} else {
				if (e.name == item.MC) {
					city.map(item1 => {
						if (item.PID == item1.PID && item.ID != item1.ID) {
							nodes.push({
								label: item1.MC,
								value: item1.MC,
								leaf: false,
								PID: item1.PID
							})
						}
					})
				}
	
			}
		})
	
		return nodes
	}
}

export {
	CitySelection
}
